import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TrustSignals = () => {
  const features = [
    {
      icon: 'Shield',
      title: 'Segurança Garantida',
      description: 'Seus dados protegidos com criptografia de ponta'
    },
    {
      icon: 'Users',
      title: '+10.000 Estudantes',
      description: 'Milhares de pessoas já transformaram suas carreiras'
    },
    {
      icon: 'Award',
      title: 'Certificação Reconhecida',
      description: 'Certificados válidos em todo território nacional'
    }
  ];

  const testimonials = [
    {
      id: 1,
      name: 'Maria Silva',
      role: 'Desenvolvedora Frontend',
      avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=64&h=64&fit=crop&crop=face',
      content: `A Academy Platform mudou minha carreira completamente. Os cursos são práticos e o suporte é excepcional.`
    },
    {
      id: 2,
      name: 'João Santos',
      role: 'Product Manager',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=64&h=64&fit=crop&crop=face',
      content: `Consegui uma promoção após concluir os cursos. O conteúdo é atual e muito bem estruturado.`
    }
  ];

  return (
    <div className="space-y-8">
      {/* Features */}
      <div className="space-y-6">
        <h3 className="text-lg font-heading font-semibold text-foreground text-center">
          Por que escolher a Academy Platform?
        </h3>
        
        <div className="space-y-4">
          {features?.map((feature, index) => (
            <div key={index} className="flex items-start space-x-4">
              <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name={feature?.icon} size={20} className="text-accent" />
              </div>
              <div>
                <h4 className="font-medium text-foreground">{feature?.title}</h4>
                <p className="text-sm text-muted-foreground font-caption">
                  {feature?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Testimonials */}
      <div className="space-y-4">
        <h3 className="text-lg font-heading font-semibold text-foreground text-center">
          O que nossos alunos dizem
        </h3>
        
        <div className="space-y-4">
          {testimonials?.map((testimonial) => (
            <div key={testimonial?.id} className="bg-card border border-border rounded-lg p-4">
              <div className="flex items-start space-x-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <Image
                    src={testimonial?.avatar}
                    alt={testimonial?.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1">
                  <div className="flex items-center space-x-2 mb-2">
                    <h4 className="font-medium text-card-foreground text-sm">
                      {testimonial?.name}
                    </h4>
                    <span className="text-xs text-muted-foreground font-caption">
                      {testimonial?.role}
                    </span>
                  </div>
                  <p className="text-sm text-muted-foreground font-caption leading-relaxed">
                    "{testimonial?.content}"
                  </p>
                  
                  {/* Rating Stars */}
                  <div className="flex items-center space-x-1 mt-2">
                    {[...Array(5)]?.map((_, i) => (
                      <Icon 
                        key={i} 
                        name="Star" 
                        size={12} 
                        className="text-secondary fill-current" 
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Security Badge */}
      <div className="text-center p-4 bg-success/5 border border-success/20 rounded-lg">
        <div className="flex items-center justify-center space-x-2 mb-2">
          <Icon name="ShieldCheck" size={20} className="text-success" />
          <span className="text-sm font-medium text-success">
            Plataforma Segura e Confiável
          </span>
        </div>
        <p className="text-xs text-muted-foreground font-caption">
          Certificada ISO 27001 • Dados criptografados • LGPD Compliant
        </p>
      </div>
    </div>
  );
};

export default TrustSignals;